import {get404Exception} from 'core/exceptions/NotFoundException';
import {TAppInitialController} from 'core/redux/types';
import {getContentPageByCode} from 'modules/content/thunks';

export const contentController: TAppInitialController<void> = async ({dispatch}, ctx) => {
    if (!ctx.query.code) {
        get404Exception();
        return;
    }

    await dispatch(getContentPageByCode(ctx.query.code, {withBreadCrumbs: true}));
};
